// extracted by mini-css-extract-plugin
export default {"container":"AttachedDocumentsComparison-module_container__jz8Re","separator":"AttachedDocumentsComparison-module_separator__OHnJ0"};